// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconCycle = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 16,
    width: 17,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-cycle">
      <svg
        className="c-icon-cycle fill-current" width={width || measurements.width}
        height={height || measurements.height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.5002 14.45H13.6002V7.24999C13.6002 6.94999 13.3502 6.67499 13.0252 6.67499C12.7002 6.67499 12.4502 6.92499 12.4502 7.24999V14.425H9.5502V9.62499C9.5502 9.32499 9.3002 9.04999 8.9752 9.04999C8.6752 9.04999 8.4002 9.29999 8.4002 9.62499V14.425H5.3252V12C5.3252 11.7 5.0752 11.425 4.7502 11.425C4.4252 11.425 4.1752 11.675 4.1752 12V14.425H2.0752V0.999988C2.0752 0.699988 1.8252 0.424988 1.5002 0.424988C1.1752 0.424988 0.950195 0.699988 0.950195 0.999988V15C0.950195 15.3 1.2002 15.575 1.5252 15.575H15.5252C15.8252 15.575 16.1002 15.325 16.1002 15C16.1002 14.675 15.8002 14.45 15.5002 14.45Z" fill={fill || '#FF892E'} />
        <path d="M4.65 9.77499C5.7 9.77499 6.55 8.92499 6.55 7.87499C6.55 7.67499 6.525 7.47499 6.45 7.29999L7.425 6.69999C7.75 6.99999 8.2 7.17499 8.675 7.17499C9.725 7.17499 10.575 6.32499 10.575 5.27499C10.575 5.09999 10.55 4.92499 10.5 4.77499L11.775 4.07499C12.125 4.39999 12.575 4.59999 13.075 4.59999C14.125 4.59999 14.975 3.74999 14.975 2.69999C14.975 1.64999 14.125 0.799988 13.075 0.799988C12.025 0.799988 11.175 1.64999 11.175 2.69999C11.175 2.82499 11.2 2.94999 11.225 3.07499L9.875 3.82499C9.55 3.54999 9.125 3.39999 8.675 3.39999C7.625 3.39999 6.775 4.24999 6.775 5.29999C6.775 5.44999 6.8 5.59999 6.825 5.74999L5.775 6.39999C5.45 6.14999 5.05 5.99999 4.625 5.99999C3.6 5.99999 2.75 6.84999 2.75 7.89999C2.75 8.92499 3.6 9.77499 4.65 9.77499ZM13.05 1.94999C13.475 1.94999 13.825 2.29999 13.825 2.72499C13.825 3.14999 13.475 3.49999 13.05 3.49999C12.625 3.49999 12.275 3.14999 12.275 2.72499C12.275 2.29999 12.625 1.94999 13.05 1.94999ZM8.65 4.52499C9.075 4.52499 9.425 4.87499 9.425 5.29999C9.425 5.72499 9.075 6.07499 8.65 6.07499C8.225 6.07499 7.875 5.72499 7.875 5.29999C7.875 4.87499 8.225 4.52499 8.65 4.52499ZM4.65 7.12499C5.075 7.12499 5.425 7.47499 5.425 7.89999C5.425 8.32499 5.075 8.67499 4.65 8.67499C4.225 8.67499 3.875 8.32499 3.875 7.89999C3.875 7.47499 4.225 7.12499 4.65 7.12499Z" fill={fill || '#FF892E'} />
      </svg>
    </Icon>
  );
};

export default IconCycle;
